import { IonContent, IonPage } from '@ionic/react';
import React from 'react';

import Logo from '@/components/common/logo/Logo';
import Padding from '@/components/common/padding/Padding';
import { ROUTES } from '@/utils/routes';

import './Legal.css';

const DeleteAccount = () => {
  return (
    <IonPage>
      <IonContent>
        <Padding>
          <Logo navigateToRootOnClick />
          <div className="container">
            <h1 className="title">ACCOUNT DELETION</h1>
            <p className="paragraph">Last updated: 11/10/2024</p>
            <h2 className="section-title">1. Introduction</h2>
            <p className="paragraph">
              Welcome to Odonto! This page provides information on how to
              request the deletion of your account.
            </p>
            <h2 className="section-title">
              2. Steps to Request Account Deletion
            </h2>
            <p className="paragraph">
              To request the deletion of your account, please follow these
              steps:
            </p>
            <ul className="list">
              <li className="list-item">
                Log in to your account on our website.
              </li>
              <li className="list-item">
                Navigate to the account settings page.
              </li>
              <li className="list-item">
                Click on the "Delete Account" button.
              </li>
              <li className="list-item">
                Follow the on-screen instructions to confirm your request.
              </li>
            </ul>
            <h2 className="section-title">3. Data Deletion and Retention</h2>
            <p className="paragraph">
              Upon account deletion, the following data will be permanently
              removed:
            </p>
            <ul className="list">
              <li className="list-item">
                Personal information such as name and phone number.
              </li>
              <li className="list-item">
                Usage data associated with your account.
              </li>
            </ul>
            <p className="paragraph">
              Some data may be retained for a period of time to comply with
              legal obligations or for legitimate business purposes.
            </p>
            <h2 className="section-title">4. Contact Us</h2>
            <p className="paragraph">
              If you have any questions about account deletion, please contact
              us:
            </p>
            <ul className="list">
              <li className="list-item">
                By email:{' '}
                <a href="mailto:hello@odonto.ph" target="_blank">
                  hello@odonto.ph
                </a>
                .
              </li>
              <li className="list-item">
                By visiting this page on our website:{' '}
                <a href="https://www.odonto.ph/help" target="_blank">
                  https://www.odonto.ph/help
                </a>
              </li>
            </ul>
          </div>
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default DeleteAccount;
